// extracted by mini-css-extract-plugin
export default {"section":"WebinarDocs_section__wubif","mobile":"WebinarDocs_mobile__ChTSG","sectionTitle":"WebinarDocs_sectionTitle__cRcDV","link":"WebinarDocs_link__Aw-Hn"};